import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _gcTimeout;
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
// src/removable.ts
import { isServer, isValidTimeout } from "./utils.js";
var Removable = (_gcTimeout = /*#__PURE__*/new WeakMap(), class Removable {
  constructor() {
    _classPrivateFieldInitSpec(this, _gcTimeout, {
      writable: true,
      value: void 0
    });
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout();
    if (isValidTimeout(this.gcTime)) {
      _classPrivateFieldSet(this, _gcTimeout, setTimeout(() => {
        this.optionalRemove();
      }, this.gcTime));
    }
  }
  updateGcTime(newGcTime) {
    this.gcTime = Math.max(this.gcTime || 0, newGcTime !== null && newGcTime !== void 0 ? newGcTime : isServer ? Infinity : 5 * 60 * 1e3);
  }
  clearGcTimeout() {
    if (_classPrivateFieldGet(this, _gcTimeout)) {
      clearTimeout(_classPrivateFieldGet(this, _gcTimeout));
      _classPrivateFieldSet(this, _gcTimeout, void 0);
    }
  }
});
export { Removable };